import { render, staticRenderFns } from "./good-registrations-toolbar.vue?vue&type=template&id=222e0bf6&"
import script from "./good-registrations-toolbar.vue?vue&type=script&lang=ts&"
export * from "./good-registrations-toolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports